import { ORDER_METHODS, RoomServiceLocationType } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'room service',
      [RoomServiceLocationType.TableService]: 'serviciu la masă',
    },
    [ORDER_METHODS.PICKUP]: 'ridicare',
    [ORDER_METHODS.DELIVERY]: 'livrare',
  },
  errors: {
    draft_validation_failed: 'Te rugăm să completezi adresa de livrare înainte de a continua.',
  },
};
